/**
 * Haptic Feedback Hook
 * Provides haptic feedback for mobile devices
 */

import { useMobile } from '../contexts/MobileContext';

export const useHapticFeedback = () => {
  const mobile = useMobile();

  const triggerHaptic = (type = 'light') => {
    if (!mobile.hasTouch || !navigator.vibrate) return;

    const patterns = {
      light: 10,
      medium: 20,
      heavy: 30,
      success: [10, 50, 10],
      error: [20, 50, 20],
      warning: [10, 30, 10],
    };

    const pattern = patterns[type] || patterns.light;
    navigator.vibrate(pattern);
  };

  return { triggerHaptic };
};







